export default __webpack_public_path__ + "3bba212f6a6148e92662d4d6fe7114b3.webp";